import { render, staticRenderFns } from "./wujiQualityPrintbatch.vue?vue&type=template&id=3ca292d0&scoped=true"
import script from "./wujiQualityPrintbatch.vue?vue&type=script&lang=js"
export * from "./wujiQualityPrintbatch.vue?vue&type=script&lang=js"
import style0 from "./wujiQualityPrintbatch.vue?vue&type=style&index=0&id=3ca292d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca292d0",
  null
  
)

export default component.exports